<template>
  <div class="hello">
    <div id="info-container">
      <div id="left-corner">
        <span id="staytionIcon">
          STAYTION
        </span>
        <span id="tag-line"> The Lived Experience, Redefined </span>
      </div>

      <span id="info-text">
        We are redefining the living experience by deploying AI and AR technologies to
        introduce new work, play, and health & wellness experiences at home.
        If you're interested in reimagining the way we live, join our mailing list to
        keep up with the latest.
      </span>
      <sign-up id="signUpBox"></sign-up>
      <div id="social-icons">
        <a href="https://twitter.com/hellostaytion"> <fa-icon :icon="['fab', 'twitter']" /> </a>
        <a href="https://instagram.com/findyourstaytion"> <fa-icon :icon="['fab', 'instagram']" /> </a>
        <a href="https://www.linkedin.com/company/findyourstaytion"> <fa-icon :icon="['fab', 'linkedin']" /> </a>
      </div>
    </div>
    <span id="careers" class="box">
      <router-link to="/careers">Careers</router-link>
    </span>
  </div>
</template>

<script>
import SignUp from '../components/SignUp'

export default {
  name: 'Home',
  data: function() {
    return {
    }
  },
  components: {
    SignUp
  },
  created () {
    document.title = "Staytion | Living Redefined";
  },
}
</script>

<style scoped>

* {
  color:#fff;
  text-decoration: none;
  font-family: proxima-nova, sans-serif;
}

.box {
  position: absolute;
  color: #fff;
  border-radius: 4px;
  padding: 4px 10px 4px 10px;
  font-weight: bold;
}

.box:hover {
  cursor: pointer;
  box-shadow: 0 0 11px rgba(33,33,33,.5);
}

#careers:hover {
  text-decoration: underline;
  text-underline-position: under;
}

.hello {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
}

#info-text {
  margin: 0;
  padding: 0;
  display: flex;
  line-height: 1.4em;
  font-weight: 500;
}

#left-corner {
	font-weight: bold;
	display: grid;
}

#tag-line {
	opacity: 0.8;
}


@media only screen and (max-device-width : 750px) {
  #info-container {
    position: absolute;
    text-align: center;
    justify-content: center;
    left: 50%;
    transform: translateX(-50%);
    top: 20%;
    width: 90vw;
    height: auto;
  }
  

  #info-text {
    margin-top: calc(36px + 1vh);
    font-size: calc(12px + 1vw);
    text-align: center;
  }

  #left-corner {
    font-weight: bold;
    display: grid;

		width: 100%;
		top: 36px;
		text-align: center;
		left: 50%;
	}

	#staytionIcon {
		letter-spacing: 5px;
		font-size: calc(36px + 0.5vw);
	}

	#tag-line {
		margin-top: 4px;	
  }

  #careers {
    font-size: calc(14px + 1vw);
    bottom: 24px;
    right: 24px;
  }

  #signUpBox {
    margin-top: calc(28px + 1vh);
  }

  #social-icons {
    margin: 0;
    padding: 0;
    margin-top: calc(28px + 1vh);
    font-size: calc(20px + 0.6vw);
  }

  #social-icons svg {
    margin-right: 1em;
    margin-left: 1em;
  }
}

@media only screen and (min-device-width : 750px) {
  #info-container {
    position: absolute;
    top: 10%;
    left: 72px;
    width: 23vw;
    height: auto;
  }

  #info-text {
    margin-top: 40px;
    font-size: 1.1vw;
    text-align: left;
  }

	#staytionIcon {
		font-size: 3vw;
	}

	#tag-line {
		margin-top: 10px;
		font-size: 1.42vw;
	}

  #careers {
    font-size: calc(12px + 0.8vw);
    bottom: 50px;
    right: 72px;
  }

  #signUpBox {
    margin-top: 50px;
    text-align: left;
  }

  #social-icons {
    margin-top: 4vh;
    bottom: 0;
    font-size: calc(20px + 0.5vw);
  }

  #social-icons svg {
    margin-right: 0.8em;
  }
}

</style>
